/**
 * <bm-status-badge status="tmpl.status"></bm-status-badge>
 *
 * Lifecycle status pill with a fixed color per status (templates, API
 * collections, biz events share the same vocabulary). Unlike
 * generic-type-pill, colors are semantic — not hashed from the label — so
 * PUBLISHED always reads green, DRAFT grey, etc. Renders nothing without a status.
 */
angular.module('bizmetryApp').component('bmStatusBadge', {
  bindings: {
    status: '<'
  },
  template: `
    <span ng-if="$ctrl.status"
          ng-style="$ctrl.style()"
          title="Status: {{ $ctrl.label() }}">{{ $ctrl.label() }}</span>
  `,
  controller: function () {
    var ctrl = this;

    // [background, text, border]
    var PALETTE = {
      PUBLISHED:      ['rgba(16,185,129,0.12)', '#047857', 'rgba(16,185,129,0.35)'],
      APPROVED:       ['rgba(20,184,166,0.12)', '#0f766e', 'rgba(20,184,166,0.35)'],
      REVIEWED:       ['rgba(20,184,166,0.12)', '#0f766e', 'rgba(20,184,166,0.35)'],
      PENDING_REVIEW: ['rgba(245,158,11,0.14)', '#92400e', 'rgba(245,158,11,0.40)'],
      DRAFT:          ['rgba(100,116,139,0.12)', '#334155', 'rgba(100,116,139,0.35)'],
      REJECTED:       ['rgba(239,68,68,0.12)',  '#991b1b', 'rgba(239,68,68,0.35)'],
      DEPRECATED:     ['rgba(168,85,247,0.12)', '#6b21a8', 'rgba(168,85,247,0.35)'],
      RETIRED:        ['rgba(120,113,108,0.14)', '#44403c', 'rgba(120,113,108,0.35)'],
      DECOMMISSIONED: ['rgba(120,113,108,0.14)', '#44403c', 'rgba(120,113,108,0.35)']
    };
    var FALLBACK = PALETTE.DRAFT;
    var _styleCache = {};   // one stable object per status (digest-friendly)

    ctrl.label = function () {
      return String(ctrl.status || '').replace(/_/g, ' ');
    };

    ctrl.style = function () {
      var key = String(ctrl.status || '').toUpperCase();
      if (!_styleCache[key]) {
        var c = PALETTE[key] || FALLBACK;
        _styleCache[key] = {
          'display':        'inline-flex',
          'align-items':    'center',
          'padding':        '2px 9px',
          'border-radius':  '10px',
          'font-size':      '10px',
          'font-weight':    '700',
          'letter-spacing': '0.05em',
          'text-transform': 'uppercase',
          'white-space':    'nowrap',
          'line-height':    '1.5',
          'background':     c[0],
          'color':          c[1],
          'border':         '1px solid ' + c[2]
        };
      }
      return _styleCache[key];
    };
  }
});
